var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgShare = function SvgShare(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.68 13.63c.72 0 1.32.6 1.32 1.2v15.24a4.7 4.7 0 0 1-4.8 4.56H10.8c-2.76 0-4.8-2.04-4.8-4.56V14.83c0-.6.6-1.2 1.2-1.2.84 0 1.32.6 1.32 1.2v15.24c0 1.2 1.08 2.28 2.16 2.28h20.64c1.2 0 2.16-1.08 2.16-2.4v-15c0-.6.48-1.2 1.2-1.2v-.12ZM21.72 6.3h.12l6.96 6.96a1.2 1.2 0 0 1 0 1.8c-.48.48-1.2.48-1.68 0H27l-4.8-4.8v12.96c0 .36-.48.72-1.2.72s-1.2-.24-1.44-.6V10.39l-4.8 4.68c-.36.48-1.2.48-1.68 0a1.2 1.2 0 0 1-.12-1.68v-.12l7.08-6.84c.48-.48 1.2-.6 1.68-.12Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/share.bd457b9bad58231e427551ae3b6dd32e.svg";